import iconBell from '~/assets/icons/bell.svg?raw'
import iconBtc from '~/assets/icons/btc-icon.svg?raw'
import iconEarnBind from '~/assets/icons/earn-bind.svg?raw'
import iconEarnGames from '~/assets/icons/earn-games.svg?raw'
import iconEarnMaterials from '~/assets/icons/earn-materials.svg?raw'
import iconEarnMembers from '~/assets/icons/earn-members.svg?raw'
import iconEarnPlan from '~/assets/icons/earn-plan.svg?raw'
import iconEarnRelation from '~/assets/icons/earn-relation.svg?raw'
import iconEarnReport from '~/assets/icons/earn-report.svg?raw'
import iconEarnYen from '~/assets/icons/earn-yen.svg?raw'
import iconEth from '~/assets/icons/eth-icon.svg?raw'
import iconUsdt from '~/assets/icons/usdt-icon.svg?raw'
import iconEye from '~/assets/icons/eye.svg?raw'
import iconEyeOff from '~/assets/icons/eye-off.svg?raw'
import iconHeadset from '~/assets/icons/headset.svg?raw'
import iconMeBets from '~/assets/icons/me-bets.svg?raw'
import iconMeDeposit from '~/assets/icons/me-deposit.svg?raw'
import iconMeKyc from '~/assets/icons/me-kyc.svg?raw'
import iconMeLang from '~/assets/icons/me-lang.svg?raw'
import iconMeLogout from '~/assets/icons/me-logout.svg?raw'
import iconMePayout from '~/assets/icons/me-payout.svg?raw'
import iconMeRecover from '~/assets/icons/me-recover.svg?raw'
import iconMeRefer from '~/assets/icons/me-refer.svg?raw'
import iconMeRefresh from '~/assets/icons/me-refresh.svg?raw'
import iconMeSecurity from '~/assets/icons/me-security.svg?raw'
import iconMeTransfer from '~/assets/icons/me-transfer.svg?raw'
import iconMeWithdraw from '~/assets/icons/me-withdraw.svg?raw'
import iconTabHome from '~/assets/icons/tab-home.svg?raw'
import iconTabMe from '~/assets/icons/tab-me.svg?raw'
import iconTabPromo from '~/assets/icons/tab-promo.svg?raw'
import iconTabRefer from '~/assets/icons/tab-refer.svg?raw'
import iconTabWallet from '~/assets/icons/tab-wallet.svg?raw'

export const appIcons = {
  bell: iconBell,
  btc: iconBtc,
  'earn-bind': iconEarnBind,
  'earn-games': iconEarnGames,
  'earn-materials': iconEarnMaterials,
  'earn-members': iconEarnMembers,
  'earn-plan': iconEarnPlan,
  'earn-relation': iconEarnRelation,
  'earn-report': iconEarnReport,
  'earn-yen': iconEarnYen,
  eth: iconEth,
  usdt: iconUsdt,
  eye: iconEye,
  'eye-off': iconEyeOff,
  headset: iconHeadset,
  'me-bets': iconMeBets,
  'me-deposit': iconMeDeposit,
  'me-kyc': iconMeKyc,
  'me-lang': iconMeLang,
  'me-logout': iconMeLogout,
  'me-payout': iconMePayout,
  'me-recover': iconMeRecover,
  'me-refer': iconMeRefer,
  'me-refresh': iconMeRefresh,
  'me-security': iconMeSecurity,
  'me-transfer': iconMeTransfer,
  'me-withdraw': iconMeWithdraw,
  'tab-home': iconTabHome,
  'tab-me': iconTabMe,
  'tab-promo': iconTabPromo,
  'tab-refer': iconTabRefer,
  'tab-wallet': iconTabWallet,
} as const

export type AppIconName = keyof typeof appIcons
